import { Grid } from '@mui/material'
import { BerthPlanningViewStore } from '@planning/pages/BerthPlanning/Stores/BerthPlanningViewStore'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { VesselVisitGeneralInformationFormStore } from '../../../Stores/VesselVisitGeneralInformationFormStore'
import { SectionSubtitle } from '../../atoms/SectionSubtitle'
import { VesselVisitVesselSubForm } from './VesselVisitVesselSubForm'
import { VesselVisitVoyageSubForm } from './VesselVisitVoyageSubForm'

type VesselVisitGeneralInformationSubFormProps = {
  store: VesselVisitGeneralInformationFormStore
  berthPlanningViewStore: BerthPlanningViewStore
  isEditMode: boolean
}

export const VesselVisitGeneralInformationSubForm = observer(
  (props: VesselVisitGeneralInformationSubFormProps) => {
    const { store } = props
    const { t } = useTranslate()
    const theme = useMinimalsTheme()

    return (
      <Grid container spacing={theme.customSpacing.s}>
        <Grid size={{ xs: 12 }}>
          <SectionSubtitle label={t('generalInformation', 'General information')} />
        </Grid>

        <VesselVisitVesselSubForm {...props} />

        <Grid size={{ xs: 12 }}>
          <VesselVisitVoyageSubForm store={store} />
        </Grid>
      </Grid>
    )
  },
)
